import React, { createContext, useCallback, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import UnvModal from './Modal'
import UnvButton from './Button'

export const ConfirmContext = createContext(null)

/**
 * Provides a confirm() function via context. Mounts a single UnvModal
 * with two buttons. Returns Promise<boolean>.
 */
const ConfirmProvider = ({ children }) => {
  const { t } = useTranslation('common')
  const [state, setState] = useState({ open: false, opts: null })
  const resolverRef = useRef(null)

  const confirm = useCallback((opts = {}) => {
    return new Promise((resolve) => {
      resolverRef.current = resolve
      setState({ open: true, opts })
    })
  }, [])

  const close = (value) => {
    const resolver = resolverRef.current
    resolverRef.current = null
    setState({ open: false, opts: null })
    resolver?.(value)
  }

  const opts = state.opts || {}
  const variant = opts.variant === 'danger' ? 'danger' : 'primary'

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <UnvModal
        open={state.open}
        onClose={() => close(false)}
        title={opts.title || t('auto.confirm.title', 'Подтвердите действие')}
        size="sm"
      >
        {opts.message ? (
          <p style={{ margin: 0, color: 'var(--color-text, #333)', fontSize: 14, lineHeight: 1.5 }}>
            {opts.message}
          </p>
        ) : null}
        <UnvModal.Footer>
          <UnvButton variant="ghost" onClick={() => close(false)}>
            {opts.cancelLabel || t('auto.confirm.cancel', 'Отмена')}
          </UnvButton>
          <UnvButton variant={variant} onClick={() => close(true)}>
            {opts.confirmLabel || t('auto.confirm.ok', 'Подтвердить')}
          </UnvButton>
        </UnvModal.Footer>
      </UnvModal>
    </ConfirmContext.Provider>
  )
}

export default ConfirmProvider
